<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GygP0Q/image/1.png?1708992389129" alt="This image is the cover for the book Top Leaf - Lost and Found"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Top Leaf - Lost and Found
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style="font-size:16px;color:black;padding:0cm;background:white;">In a moment of separation, a young boy finds himself lost, distanced from his mother.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style="font-size:16px;color:black;padding:0cm;background:white;">But solace comes from an unexpected friend – Top Leaf, perched high in the trees.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style="font-size:16px;color:black;padding:0cm;background:white;">Although Top Leaf cannot communicate with words, he employs the gentle gestures of sign language, offering comfort and guidance.</span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style="font-size:16px;color:black;padding:0cm;background:white;">Together, they embark on a heartfelt journey to reunite the boy with his mother, proving that help can come from the most unexpected places.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa LaRae
      </h2>
      
      <p class="authorDescription body article"><p>Lisa LaRae spent her childhood in the Ozarks, Missouri. Lisa was the youngest of three children, an oops child, so she was 9-10 years younger than the oldest. Lisa spent much of her time finding her own way and her own friends throughout her youth. Lisa&rsquo;s family hit hard times in the early 80s she had to drop out of high school to work in construction. Lisa then moved into insurance and met her husband, Randy, had two sons Zachary and Chad. Lisa and Randy are happily married now for 30 years. Lisa went to college in her 40s and that&rsquo;s when she started to write. Lisa also writes children&rsquo;s books in her spare time as well as poetry. Writing is a hobby that became an outlet but mostly a dream come true.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f843b4a